import { useCallback } from 'react';
import { DropdownItem } from 'reactstrap';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlag } from '@fortawesome/free-solid-svg-icons';
import { httpClient } from '@s20/services/httpClient';
import { Modal } from '../../../../common/Modal';
import ValidatedSelect from '../../../../common/forms/ValidatedSelect';
import { ApiRoutes } from '../../../../Common';
import { Textarea, toasty } from '../../../../common/forms/FormElements';
import { useJobQueryKey } from '../../common/useJobQueryKey.hook';
import { FlagTypeOptions } from '../../../../dispatchIssues/DispatchIssuesConstants';

const FlagJobModalBody = () => (
    <>
        <ValidatedSelect
            id="flagType"
            name="flagTypeId"
            label="Flag Type"
            required
            options={FlagTypeOptions}
        />

        <Textarea
            id="flagNotes"
            name="notes"
            label="Additional Notes"
            placeholder="Describe the issue..."
            rows={3}
        />
    </>
);

const defaultOnSuccess = () => { };

export const useHandleFlagJob = ({
    job, day, onSuccess = defaultOnSuccess,
}) => {
    const handleFlagJobSubmit = useMutation({
        mutationFn: ({ flagTypeId, notes }) => {
            const dispatchFlagTypeId = parseInt(flagTypeId, 10);

            return httpClient.post(ApiRoutes.dispatchFlag.flag(), {
                jobId: job.id,
                flagDate: day,
                dispatchFlagTypeId,
                notes: notes || null,
            });
        },
        onSuccess: () => {
            toasty.success('Job flagged successfully.');
            onSuccess();
        },
    });

    const handleFlagJob = useCallback(() => {
        Modal.show({
            title: (
                <>
                    <FontAwesomeIcon
                        icon={faFlag}
                        className="mr-2 text-danger"
                    />
                    Flag Job
                </>
            ),
            initialValues: { flagTypeId: 1, notes: '' },
            SaveButtonProps: { label: 'Flag Job', color: 'danger' },
            onSubmit: handleFlagJobSubmit.mutateAsync,
            body: () => (
                <FlagJobModalBody />
            ),
        });
    }, [handleFlagJobSubmit.mutateAsync]);

    return handleFlagJob;
};

export const FlagJob = ({ day, ...job }) => {
    const { queryKey } = useJobQueryKey();
    const queryClient = useQueryClient();

    const handleSuccess = useCallback(() => {
        queryClient.invalidateQueries({ queryKey });
    }, [queryClient, queryKey]);

    const handleFlagJob = useHandleFlagJob({
        job, day, onSuccess: handleSuccess,
    });

    return (
        <DropdownItem
            className="text-danger"
            onClick={handleFlagJob}
        >
            <FontAwesomeIcon icon={faFlag} />
            <span>Flag Job</span>
        </DropdownItem>
    );
};

